// Helpers for sending CTAs to the external self-schedule app (/schedule).
// /schedule is NOT a Gatsby route — it's a separate app — so these use a full
// page navigation (location.assign / window.open) rather than Gatsby's <Link>.

// Build the self-schedule URL with the full current page URL (query params and
// all) URI-encoded into returnUrl, so /schedule can send the user back here
// after they complete or exit the flow.
// e.g. /schedule?returnUrl=https%3A%2F%2Fmilanlaser.com%2Fspecials%2F
//
// entry: an optional cheap signal for how the user arrived (e.g. 'onpage' for
// the on-page handoff flow — see selfScheduleHandoff.js). The authoritative
// payload for that flow lives in sessionStorage, not the URL.
export function getSelfScheduleUrl({ entry } = {}) {
    if (typeof window === 'undefined') return '/schedule';
    const returnUrl = `returnUrl=${encodeURIComponent(window.location.href)}`;
    const entryParam = entry ? `&entry=${encodeURIComponent(entry)}` : '';
    return `/schedule?${returnUrl}${entryParam}`;
}

export function goToSelfSchedule(newTab = false) {
    if (typeof window === 'undefined') return;
    const url = getSelfScheduleUrl();
    // New tab must use window.open (within the click gesture); same-tab uses
    // location.assign — clearer than window.open('_self') and avoids webview
    // quirks. assign keeps a history entry so the back button returns here.
    if (newTab) {
        window.open(url, '_blank');
    } else {
        window.location.assign(url);
    }
}

// Navigates into the SSA on-page handoff flow (WEBDEV-4043). Always same-tab:
// this is called from a form submit, not a click gesture that could carry
// new-tab intent.
export function goToSelfScheduleOnPage() {
    if (typeof window === 'undefined') return;
    window.location.assign(getSelfScheduleUrl({ entry: 'onpage' }));
}
